/*
 * One owner for the `(n)` prefix on the page title. Each source (unread
 * notifications, agents waiting while the tab is hidden) sets its own count
 * and the title shows their sum, so they never overwrite each other.
 */
const counts = new Map<string, number>();

const PREFIX = /^\(\d+\)\s*/;

export const titleBase = (): string => document.title.replace(PREFIX, "");

export const renderTitle = (): void => {
  if (typeof document === "undefined") return;
  let total = 0;
  for (const n of counts.values()) total += n;
  const base = titleBase();
  document.title = total > 0 ? `(${total}) ${base}` : base;
};

export const setTitleCount = (source: string, count: number): void => {
  if (count > 0) counts.set(source, count);
  else counts.delete(source);
  renderTitle();
};
